import { render, staticRenderFns } from "./AppsView.vue?vue&type=template&id=73275dd1&scoped=true"
import script from "./AppsView.vue?vue&type=script&lang=js"
export * from "./AppsView.vue?vue&type=script&lang=js"
import style0 from "./AppsView.vue?vue&type=style&index=0&id=73275dd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73275dd1",
  null
  
)

export default component.exports